import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-role",
  "use": "icon-role-usage",
  "viewBox": "0 0 1170 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1170 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-role\"><path d=\"M146.285714 0h877.714286a146.285714 146.285714 0 0 1 146.285714 146.285714v731.428572a146.285714 146.285714 0 0 1-146.285714 146.285714H146.285714a146.285714 146.285714 0 0 1-146.285714-146.285714V146.285714a146.285714 146.285714 0 0 1 146.285714-146.285714z m219.428572 585.142857a146.285714 146.285714 0 1 0 0-292.571428 146.285714 146.285714 0 0 0 0 292.571428z m-206.994286 146.285714h413.988571a219.501714 219.501714 0 0 0-413.988571 0zM731.428571 365.714286v73.142857h292.571429V365.714286h-292.571429z m0 219.428571v73.142857h292.571429V585.142857h-292.571429z\" p-id=\"42919\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/role.svg
// module id = cqqK
// module chunks = 12